import { FaWhatsapp, FaMapMarkerAlt, FaInstagram } from 'react-icons/fa'
import {
  Container,
  ConteudoContato,
  InfoLateral,
  Formulario,
  ButtonGroup,
  CustomAlert
} from './styles'
import { useState } from 'react'

const Contato = () => {
  const [formData, setFormData] = useState({
    name: '',
    instrument: 'Guitarra'
  })

  const [showAlert, setShowAlert] = useState(false)

  const handleSendMessage = (platform: 'whatsapp' | 'instagram') => {
    const message = `Olá! Meu nome é ${formData.name}. Gostaria de saber mais sobre as aulas de ${formData.instrument}.`
    const encodedMessage = encodeURIComponent(message)

    if (!formData.name.trim()) {
      alert('Por favor, digite seu nome antes de enviar! :)')
      return
    }

    if (platform === 'whatsapp') {
      window.open(
        `https://wa.me/5521970117784?text=${encodedMessage}`,
        '_blank'
      )
    } else {
      navigator.clipboard.writeText(message)
      setShowAlert(true)
      setTimeout(() => {
        window.open('https://instagram.com/torquatogtr', '_blank')
      }, 2000)
      setTimeout(() => {
        setShowAlert(false)
      }, 4000)
    }
  }

  return (
    <Container id="contato">
      <ConteudoContato>
        <InfoLateral>
          <h2>Vamos tocar juntos?</h2>
          <p>
            Tire suas dúvidas sobre horários, planos e metodologia diretamente
            comigo.
          </p>

          <div className="cartao-info">
            <div className="icone-box">{FaWhatsapp({})}</div>
            <div>
              <h4>WhatsApp</h4>
              <p>(21) 970117784</p>
            </div>
          </div>

          <div className="cartao-info">
            <div className="icone-box">{FaInstagram({})}</div>
            <div>
              <h4>Instagram</h4>
              <p>torquatogtr</p>
            </div>
          </div>

          <div className="cartao-info">
            <div className="icone-box">{FaMapMarkerAlt({})}</div>
            <div>
              <h4>Localização</h4>
              <p>Aulas em domicílio</p>
            </div>
          </div>
        </InfoLateral>

        <Formulario>
          <div className="grupo-input">
            <h3>Mande uma mensagem</h3>
            <label>Seu Nome</label>
            <input
              type="text"
              placeholder="Como podemos te chamar?"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
          </div>
          <div className="grupo-input">
            <label>Instrumento de Interesse</label>
            <select
              value={formData.instrument}
              onChange={(e) =>
                setFormData({ ...formData, instrument: e.target.value })
              }
            >
              <option value="Violão">Violão</option>
              <option value="Guitarra">Guitarra</option>
              <option value="Teclado">Teclado</option>
              <option value="Contrabaixo">Contrabaixo</option>
              <option value="Cavaquinho">Cavaquinho</option>
              <option value="Ukulelê">Ukulelê</option>
              <option value="Bateria">Bateria</option>
            </select>
          </div>

          {/* Substituímos o botão simples pelo grupo de botões estilizados */}
          <ButtonGroup>
            <button
              className="btn-wpp"
              disabled={!formData.name.trim()}
              onClick={() => handleSendMessage('whatsapp')}
            >
              {FaWhatsapp({})}WhatsApp
            </button>
            <button
              className="btn-insta"
              disabled={!formData.name.trim()}
              onClick={() => handleSendMessage('instagram')}
            >
              {FaInstagram({})}Instagram
            </button>
            {showAlert && (
              <CustomAlert>
                <span style={{ color: '#007bff', fontWeight: 'bold' }}>✓</span>
                Mensagem copiada! Cole no Direct do Instagram.
              </CustomAlert>
            )}
          </ButtonGroup>
        </Formulario>
      </ConteudoContato>
    </Container>
  )
}

export default Contato
